import { BanksLoadingSkeleton } from './BankSkeleton';
import bankStyles from '../../assets/css/banks.module.css';
import { BankRow } from './BankRow';
import { Page } from './BankPages';
import { Bank } from '../../services/interfaces/bank.interface';

interface BankPageProps {
	page: Page;
	skeletonCount?: number;
	onBankSelect(bank: Bank): void;
}

export const BankPage = ({ page, skeletonCount, onBankSelect }: BankPageProps) => {
	if (!page) return <BanksLoadingSkeleton count={skeletonCount || 3} />;

	return (
		<div className={bankStyles['bank-page']}>
			{page.banks.map((bank) => (
				<BankRow bank={bank} key={bank.name} onBankSelect={onBankSelect} />
			))}
		</div>
	);
};
